import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useFetch } from "../../../../Hooks/useFetch";
import { key } from "../../../../data/queryKeys";
import { api } from "../../../../Services/api";
import styled from "styled-components";
import MydashboardModalView from "../Projects/ProjectDashboard/style";
import { ReactComponent as EditIcon } from "../../../../assets/images/icons/blue_edit_icon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/AdminImages/User/bluedelete12.svg";
import {
  Input,
  Button as AntdButton,
  Select,
  Form as AntdForm,
  message,
  InputNumber,
} from "antd";
// Import global styles for dropdown override
import "./PriorityListOverride.css";
import Search from "../../Admin/Search/Search";
import CustomSpinInput from "./CustomSpinInput";
import { setAllPriorityData } from "../../../../redux/Tracking/actionCreator";
import Searchbox from "../../../Reuseable/Searchbox";

const getAntdColumns = (renderDescriptionCell) => [
  {
    title: "Projects",
    dataIndex: "projects",
    key: "projects",
    sorter: (a, b) => (a.projects || "").localeCompare(b.projects || ""),
  },
  {
    title: "Priority",
    dataIndex: "priority",
    key: "priority",
    sorter: (a, b) => (a.priority || "").localeCompare(b.priority || ""),
  },
  {
    title: "Timeline",
    dataIndex: "timeline",
    key: "timeline",
    sorter: (a, b) => (a.timeline || "").localeCompare(b.timeline || ""),
  },
];

const priorityHoursMap = {
  "Blocker Level 1": 4,
  "Blocker Level 2": 8,
  Major: 16,
  Medium: 40,
  Low: 80,
};

// PriorityListHeader: header with add button and search box
function PriorityListHeader({ onAddClick, searchValue, onSearchChange }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 10,
      }}
    >
      <div
        className="Userlist-Search"
        style={{ display: "flex", alignItems: "center" }}
      >
        {/* <span className="mt-1 mx-2">Filter:</span> */}
        {/* <Search
          userFilter="userFilter"
          type="userFilter"
          placeholder="Search"
          search={searchValue}
          handleSearch={val => onSearchChange({ target: { value: val } })}
        /> */}
        <Searchbox
          handleSearch={(val) => onSearchChange({ target: { value: val } })}
          value={searchValue}
          placeholder={"Search"}
        />{" "}
      </div>
      <Button
        style={{
          backgroundColor: "#4EB6EE",
          color: "#fff",
          borderColor: "#4EB6EE",
          borderRadius: "8px",
          fontWeight: 400,
        }}
        variant="primary"
        onClick={onAddClick}
      >
        + Add
      </Button>
    </div>
  );
}

function AddnewPriority() {
  const [showModal, setShowModal] = useState(false);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [priorityLabel, setPriorityLabel] = useState("");
  const [timeline, setTimeline] = useState("");
  const [hours, setHours] = useState("");
  const [days, setDays] = useState("");
  const [descExpand, setDescExpand] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [sortState, setSortState] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [editRow, setEditRow] = useState(null);
  // 1. Add state for view modal and selected project
  const [viewModal, setViewModal] = useState(false);
  const [viewProject, setViewProject] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const dispatch = useDispatch();
  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );

  const user = useSelector((state) => state.Auth.user);
  const { data: allProjectsRes } = useFetch(
    key.get_all_projects,
    `/trackingprojects/${trackingClientId}`,
    () => {},
    () => {},
    false,
    true,
  );

  const allProjects = (allProjectsRes?.data?.Items || []).map((p) => ({
    label: p.label,
    value: p.trackingprojectid,
  }));

  const priorityList = useSelector((state) => state.Tracking.allPriorityData);

  const fetchPriorities = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(`/tracking/priority/${trackingClientId}`);
      const allProjectsMap = Object.fromEntries(
        allProjects.map((p) => [p.value, p.label]),
      );
      const mappedItems = (res?.data?.data || []).flatMap((item) => {
        const projectName =
          allProjectsMap[item.trackingprojectid] || item.trackingprojectid;
        const trackingprojectid = item.trackingprojectid;
        return (item.prioritydata || []).map((priority) => ({
          ...priority,
          projects: projectName,
          trackingprojectid,
        }));
      });
      dispatch(setAllPriorityData(mappedItems));
    } catch (err) {
      //setError('Failed to fetch priorities');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (trackingClientId && (!priorityList || priorityList.length === 0)) {
      fetchPriorities();
    }
    // eslint-disable-next-line
  }, [trackingClientId]);
  const [antdForm] = AntdForm.useForm();
  const handleAddClick = () => {
    setShowModal(true);
    setEditRow(null);
    setSelectedProjects([]);
    antdForm.setFieldsValue({ project: undefined });
    setHours("");
    setDays("");
  };

  const handleRowClick = (record) => {
    console.log("Clickedrecord", record);
    setEditRow(record);
    setShowModal(true);
    const projectObj = allProjects.find(
      (p) => p.value === record.trackingprojectid,
    );
    setSelectedProjects(projectObj ? [projectObj] : []);
    antdForm.setFieldsValue({ project: record.trackingprojectid });
    // Find all priorities for this project
    const projectRows = priorityList.filter(
      (p) => p.trackingprojectid === record.trackingprojectid,
    );
    // Prefill the priorities array for the form (include hours and days)
    antdForm.setFieldsValue({
      project: record.trackingprojectid,
      priorities: projectRows.map((row) => ({
        priority: row.priority,
        hours: row.hours,
        days: row.days,
      })),
    });
    setPriorityLabel("");
    setTimeline("");
    setHours("");
    setDays("");
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedProjects([]);
    setPriorityLabel("");
    setTimeline("");
    setEditRow(null);
    antdForm.resetFields();
    setHours("");
    setDays("");
  };

  const handleTimelineChange = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z0-9 ]*$/.test(value)) {
      setTimeline(value);
    }
  };

  // After add/edit/delete, update Redux
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      if (editRow) {
        // Edit mode - PATCH
        await api.patch(`/tracking/priority`, {
          trackingClientId,
          trackingProjectId: selectedProjects.map((project) => ({
            trackingProjectId: project.value,
          })),
          priority: priorityLabel,
          hours,
          days,
        });
      } else {
        // Add mode - POST
        await api.post("/tracking/priority", {
          trackingClientId,
          trackingProjectId: selectedProjects.map((project) => ({
            trackingProjectId: project.value,
          })),
          priority: priorityLabel,
          hours,
          days,
          projectName: selectedProjects.map((project) => ({
            projectName: project.label,
          })),
        });
      }
      await fetchPriorities();
      handleClose();
    } catch (err) {
      setError("Failed to " + (editRow ? "update" : "add") + " priority");
      message.error("Failed to " + (editRow ? "update" : "add") + " priority");
    } finally {
      setLoading(false);
    }
  };

  // Search filter
  const filteredList = priorityList.filter(
    (item) =>
      item.projects?.toLowerCase?.().includes(searchValue.toLowerCase()) ||
      "" ||
      item.priority?.toLowerCase?.().includes(searchValue.toLowerCase()) ||
      "",
  );

  // Sorting stub (implement as needed)
  const handleSort = (col) => {
    setSortState((prev) => ({
      ...prev,
      [col]: prev[col] === "asc" ? "desc" : "asc",
    }));
    // Sorting logic can be added here
  };

  // Description cell renderer
  // const renderDescriptionCell = ({ row }) => {
  //   const id = row.original.id || row.original.trackingpriorityid;
  //   const expanded = descExpand[id];
  //   if (!desc) return '';
  //   if (desc.length <= 40) return desc;
  //   return (
  //     <>
  //       {expanded ? desc : desc.slice(0, 40) + '...'}{' '}
  //       <span
  //         style={{ color: '#4EB6EE', cursor: 'pointer' }}
  //         onClick={() => setDescExpand((prev) => ({ ...prev, [id]: !expanded }))}
  //       >
  //         {expanded ? 'View Less' : 'View More'}
  //       </span>
  //     </>
  //   );
  // };

  // const columns = getAntdColumns(renderDescriptionCell);

  // Styled-component for the table, copied exactly from TableWrap
  const PriorityTableWrap = styled.div`
    .myDashBoard_table {
      border-radius: 8px;
      width: 100%;
      border-collapse: collapse;
    }
    .select_check_box {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .timeline_isempty {
      color: #aaaaaa;
      opacity: 0.8;
    }
    .table_check_box {
      cursor: pointer;
      width: 16px;
      height: 16px;
      color: #fff;
      accent-color: #4eb6ee;
    }
    .table_check_box:checked {
      color: #fff;
      background-color: #fff;
    }
    .table_check_box ~ .checkmark {
      background-color: #fff;
      color: #fff;
    }
    .table-striped > tbody > tr:nth-of-type(odd) > * {
      color: ${({ theme }) => theme["body-text"]};
      --bs-table-accent-bg: unset;
    }
    .table-hover > tbody > tr:hover > * {
      color: ${({ theme }) => theme["body-text"]};
      --bs-table-accent-bg: unset;
    }
    .table-bordered > :not(caption) > * > * {
      border-width: 0;
    }
    .table > :not(:first-child) {
      border-top: 1px solid ${({ theme }) => theme["border"]};
    }
    .table {
      border-color: transparent;
    }
    table {
      border-collapse: collapse;
      thead {
        th {
          padding: 10px !important;
          color: ${({ theme }) => theme["body-text"]};
          background-color: ${({ theme }) => theme["tableHeadBg"]};
        }
      }
      tbody {
        tr {
          cursor: pointer;
          box-shadow: inset 0 1px 0 0 ${({ theme }) => theme["bordercolor"]};
          td {
            line-height: 1.42857143;
            vertical-align: middle;
            padding: 10px !important;
            color: ${({ theme }) => theme["body-text"]};
            font-size: 14px;
          }
          th {
            line-height: 1.42857143;
            vertical-align: middle;
            padding: 10px !important;
            color: ${({ theme }) => theme["body-text"]};
            font-size: 14px;
            white-space: nowrap;
          }
        }
      }
      .drag-indicator {
        .drag-icon {
          opacity: 0.1;
        }
        &:hover {
          .drag-icon {
            opacity: 0.8;
          }
        }
      }
      .table > :not(:first-child) {
        border-top: 1px solid currentColor;
      }
      .imgfirstLetr {
        display: inline-block;
        background-color: #c3c3c3;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        color: #fff;
        box-shadow: inherit;
        font-size: 18px;
        padding: 6px 6px;
        margin: 0 auto;
        text-align: center;
        vertical-align: middle;
      }
      .imgFirstLetMain {
        span {
          display: inline-block;
          vertical-align: inherit;
        }
      }
      .btn-outline-light {
        color: #212529;
        border-color: #d3d3d3;
        &:hover {
          color: #212529;
          background-color: #f8f9fa;
          border-color: #999;
        }
      }
      .indicator {
        background: #5db239;
        border-radius: 50%;
        display: block;
        height: 8px;
        width: 8px;
        padding: 1px;
        position: absolute;
        bottom: 5px;
        top: inherit;
        right: -3px;
        text-align: center;
        transition: top 0.1s ease-out;
        font-size: 0.675rem;
        color: #ffffff;
      }
      .actionLink {
        svg {
          height: 25px;
          path {
            fill: ${({ theme }) => theme["orange-color"]};
          }
        }
        padding: 5px;
      }
    }
    table.border-0 {
      tbody {
        tr {
          td {
            border: inherit;
            span {
              font-size: 14px;
            }
          }
          th {
            border: inherit;
          }
        }
      }
    }
    .table {
      &:not(:first-child) {
        border-top: inherit;
      }
    }
    @media (max-width: 991px) {
      .drag-indicator {
        .drag-icon {
          display: none;
        }
      }
      table {
        tbody {
          tr {
            td {
            }
            th {
              white-space: nowrap;
            }
          }
        }
      }
    }
    thead th {
      padding: 10px !important;
      color: ${({ theme }) => theme["body-text"]};
      background-color: ${({ theme }) => theme["tableHeadBg"]};
    }
    // thead th:first-child {
    //   border-top-left-radius: 12px;
    // }
    // thead th:last-child {
    //   border-top-right-radius: 12px;
    // }
  `;

  // Add a simple loader styled-component
  const LoaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 120px;
  `;
  const Spinner = styled.div`
    border: 3px solid #f3f3f3;
    border-top: 3px solid #4eb6ee;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 1s linear infinite;
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;

  // Prepare columns and data for the table
  const tableColumns = [
    <th key="projectName">Project Name</th>,
    <th key="priorityName">Priority Name</th>,
    <th key="timeline">Time Line</th>,
    <th key="createdOn">Created On</th>,
    <th key="createdBy">Created By</th>,
    <th key="actions" style={{ textAlign: "center" }}>
      Actions
    </th>,
  ];

  const handleDelete = (row) => {
    setRowToDelete(row);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!rowToDelete) return;
    setLoading(true);
    setError(null);
    try {
      await api.delete(
        `/tracking/priority/${trackingClientId}/${rowToDelete.trackingprojectid}`,
        {
          headers: {
            authorizationToken: localStorage.getItem("token"),
          },
        },
      );
      await fetchPriorities();
      setShowDeleteModal(false);
      setRowToDelete(null);
    } catch (err) {
      setError("Failed to delete priorities for this project.");
      message.error("Failed to delete priorities for this project.");
    } finally {
      setLoading(false);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setRowToDelete(null);
  };

  // Fetch all members for userId to personname mapping
  const { data: allMembersRes } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    true,
  );
  const allMembers = allMembersRes?.data || [];

  // 2. Group priorities by project for table display
  const groupedProjects = {};
  filteredList.forEach((row) => {
    const projectName = row.projects;
    const key = row.trackingprojectid;
    if (!groupedProjects[key])
      groupedProjects[key] = {
        projectName,
        createdOn: row.createdon,
        createdBy: row.createdby,
        trackingprojectid: row.trackingprojectid,
        projectRows: [],
      };
    groupedProjects[key].projectRows.push(row);
  });

  // 3. Table columns for outer table
  const outerTableColumns = [
    <th key="projectName">Project Name</th>,
    <th key="createdOn">Created On</th>,
    <th key="createdBy">Created By</th>,
    <th key="actions"></th>,
  ];

  useEffect(() => {
    if (showModal && !editRow) {
      const initialPriorities = priorityListData.map((p) => ({
        priority: p.value,
        hours: priorityHoursMap[p.value],
        days: Number((priorityHoursMap[p.value] / 8).toFixed(2)),
        timeline: priorityHoursMap[p.value],
      }));

      antdForm.resetFields(); // clear old values
      antdForm.setFieldsValue({ priorities: initialPriorities }); // set defaults
    }
  }, [showModal, editRow]);

  // 4. Table rows for outer table
  const outerTableRows = Object.values(groupedProjects).map((group, idx) => {
    // Created On (format as readable date)
    let createdOn = group.createdOn;
    if (createdOn) {
      try {
        createdOn = new Date(createdOn).toLocaleDateString();
      } catch (e) {}
    }
    // Created By (map userId to personname)
    let createdBy = group.createdBy || "";
    const member = allMembers.find(
      (m) => m.userId === createdBy || m.trackinguserid === createdBy,
    );
    if (member && member.personname) {
      createdBy = member.personname;
    }
    return (
      <tr
        key={group.trackingprojectid}
        style={{ cursor: "pointer" }}
        onClick={() => {
          setViewProject(group);
          setViewModal(true);
        }}
      >
        <td>{group.projectName}</td>
        <td>{createdOn}</td>
        <td>{createdBy}</td>

        <td style={{ textAlign: "center" }}>
          {/* Actions: Edit and Delete icons */}
          <span
            className="actionLink"
            style={{ marginRight: 8, cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              handleRowClick(group);
            }}
            title="Edit"
          >
            <EditIcon />
          </span>
          <span
            className="actionLink"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(group);
            }}
            title="Delete"
          >
            <DeleteIcon />
          </span>
        </td>
      </tr>
    );
  });

  const projectVal = AntdForm.useWatch("project", antdForm);
  const priorityVal = AntdForm.useWatch(
    ["priorities", 0, "priority"],
    antdForm,
  );
  const handleAntdFormSubmit = async (values) => {
    setLoading(true);
    setError(null);
    try {
      const projectObj = allProjects.find(
        (opt) => opt.value === values.project,
      );
      const projectName = projectObj ? projectObj.label : "";
      const createdby = user?.trackinguserid || "";
      const createdon = new Date().toISOString();
      const prioritiesArr = values.priorities || [];
      const prioritydata = prioritiesArr.map((row) => ({
        priority: row.priority,
        hours: row.hours,
        days: row.days,
        createdby,
        createdon,
      }));
      if (editRow) {
        const updatedby = user?.trackinguserid || "";
        const updatedon = new Date().toISOString();
        const patchedPriorityData = prioritydata.map((item) => ({
          ...item,
          updatedby,
          updatedon,
        }));
        await api.patch(`/tracking/priority`, {
          trackingClientId: trackingClientId,
          trackingProjectId: values.project,
          projectName,
          prioritydata: patchedPriorityData,
        });
      } else {
        // POST for add
        await api.post("/tracking/priority", {
          trackingClientId: trackingClientId,
          trackingProjectId: values.project,
          projectName,
          prioritydata,
        });
      }
      await fetchPriorities();
      handleClose();
    } catch (err) {
      setError("Failed to " + (editRow ? "update" : "add") + " priority");
      message.error("Failed to " + (editRow ? "update" : "add") + " priority");
    } finally {
      setLoading(false);
    }
  };

  const usedProjectIds = priorityList.map((item) => item.trackingprojectid);
  const availableProjects = editRow
    ? allProjects
    : allProjects.filter((p) => !usedProjectIds.includes(p.value));
  console.log("editRoweditRow", editRow);

  const priorityListData = [
    { label: "Blocker Level 1", value: "Blocker Level 1" },
    { label: "Blocker Level 2", value: "Blocker Level 2" },
    { label: "Major", value: "Major" },
    { label: "Medium", value: "Medium" },
    { label: "Low", value: "Low" },
  ];

  const ViewPriorityModal = ({ show, onHide, project, allProjects }) => {
    if (!project) return null;
    const projectObj = allProjects.find(
      (opt) => opt.label === project.projectName,
    );
    return (
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View Priority</Modal.Title>
        </Modal.Header>
        <Form>
          <Modal.Body style={{ minWidth: 420, padding: "0px 20px" }}>
            {/* <div style={{ marginBottom: 16 }}></div>
            <div style={{ marginBottom: 16 }}></div> */}
            <div style={{ width: "100%" }}>
              <table
                className="myDashBoard_table"
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: 0,
                  background: "rgba(255,255,255,0.03)",
                  // borderRadius: "12px",
                  // marginTop: 12,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: "center",
                        fontWeight: 400,
                        color: "#fff",
                        padding: "12px 8px",
                        background: "#535353",
                        // borderTopLeftRadius: 12,
                        border: "1px solid #535353",
                      }}
                    >
                      Priority Name
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        fontWeight: 400,
                        color: "#fff",
                        padding: "12px 8px",
                        background: "#535353",
                        border: "1px solidrgb(208, 218, 223)",
                      }}
                    >
                      Hours(h)
                    </th>
                    <th
                      style={{
                        textAlign: "center",
                        fontWeight: 400,
                        color: "#fff",
                        padding: "12px 8px",
                        background: "#535353",
                        // borderTopRightRadius: 12,
                        border: "1px solid #535353",
                      }}
                    >
                      Days(d)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {project.projectRows.map((row, idx) => (
                    <tr
                      key={row.priorityid || row.id || idx}
                      style={{ background: "rgba(255, 255, 255, 0)" }}
                    >
                      <td
                        style={{
                          textAlign: "center",
                          padding: "10px 8px",
                          border: "none",
                          color: "#fff",
                          borderBottom: "1px solid rgba(255,255,255,0.10)",
                          borderLeft: idx === 0 ? "none" : undefined,
                          wordBreak: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {row.priority}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "10px 8px",
                          border: "none",
                          color: "#fff",
                          borderBottom: "1px solid rgba(255,255,255,0.10)",
                          wordBreak: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {row.hours}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "10px 8px",
                          border: "none",
                          color: "#fff",
                          borderBottom: "1px solid rgba(255,255,255,0.10)",
                          borderRight:
                            idx === project.projectRows.length - 1
                              ? "none"
                              : undefined,
                          borderRadius:
                            idx === project.projectRows.length - 1
                              ? "0 0 12px 0"
                              : undefined,
                          wordBreak: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {row.days}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={onHide}
              style={{
                minWidth: "100px",
                height: "40px",
                borderRadius: "8px",
                fontWeight: 400,
                background: "#4EB6EE",
                color: "#fff",
                borderColor: "#4EB6EE",
              }}
            >
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };

  return (
    <div
      style={{ background: "#3E3F3E", padding: "15px", borderRadius: "10px" }}
    >
      <style>{`
        .add-priority-modal .ant-select-selector,
        .add-priority-modal .ant-select-focused .ant-select-selector,
        .add-priority-modal .ant-select-selector:focus,
        .add-priority-modal .ant-select-selector:hover {
          border: 1px solid rgb(255 255 255 / 20%) !important;
          border-radius: 8px !important;
          box-shadow: none !important;
        }
      `}</style>
      <PriorityListHeader
        onAddClick={() => {
          setEditRow(null);
          handleAddClick();
        }}
        searchValue={searchValue}
        onSearchChange={(e) => setSearchValue(e.target.value)}
      />
      {loading && <div>Loading...</div>}
      <MydashboardModalView>
        <PriorityTableWrap>
          <div
            className="table-view-card"
            style={{ width: "100%", margin: 0, padding: 0 }}
          >
            {loading ? (
              <LoaderWrapper>
                <Spinner />
              </LoaderWrapper>
            ) : filteredList.length === 0 ? (
              <div
                style={{
                  color: "#fff",
                  textAlign: "center",
                  padding: "40px 0",
                  fontSize: 18,
                  fontWeight: 400,
                  opacity: 0.85,
                  letterSpacing: 0.2,
                }}
              >
                No Task Found
              </div>
            ) : (
              <table
                className="myDashBoard_table"
                style={{
                  width: "100%",
                  borderRadius: "0px",
                  overflow: "hidden",
                }}
              >
                <thead>
                  <tr>{outerTableColumns}</tr>
                </thead>
                <tbody>{outerTableRows}</tbody>
              </table>
            )}
          </div>
        </PriorityTableWrap>
      </MydashboardModalView>
      <ViewPriorityModal
        show={viewModal}
        onHide={() => setViewModal(false)}
        project={viewProject}
        allProjects={allProjects}
      />
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        size="lg"
        className="add-priority-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editRow ? "Edit Priority" : "Add Priority"}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Modal.Body style={{ minWidth: 520, padding: "0px 20px" }}>
            <AntdForm
              form={antdForm}
              layout="vertical"
              initialValues={{
                project:
                  allProjects.find(
                    (opt) => opt.value === antdForm.getFieldValue("project"),
                  ) || undefined,
                priorities: editRow
                  ? [
                      {
                        priority: priorityLabel,
                        timeline: timeline,
                        hours: "",
                        days: "",
                      },
                    ]
                  : [{ priority: "", timeline: "", hours: "", days: "" }],
              }}
              onFinish={handleAntdFormSubmit}
            >
              <div style={{ display: "flex", gap: 32, marginBottom: 10 }}>
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      color: "white",
                      marginBottom: 6,
                      display: "block",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    Project Names
                  </label>
                  <AntdForm.Item
                    name="project"
                    rules={[
                      { required: true, message: "Please select a project" },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    {console.log("Availableselect", availableProjects)}
                    <Select
                      options={availableProjects}
                      placeholder="Select project"
                      disabled={!!editRow}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      dropdownMatchSelectWidth={true}
                      showSearch
                      optionFilterProp="label"
                      style={{
                        width: "100%",
                        maxWidth: 500,
                        background: "transparent",
                        color: "black",
                        border: "1px solid #fff",
                        borderRadius: "8px",
                        boxShadow: "none",
                      }}
                      dropdownStyle={{
                        background: "#23272b",
                        color: "white",
                        borderRadius: "8px",
                      }}
                      className="white-dropdown custom-priority-select"
                    />
                  </AntdForm.Item>
                </div>
                <div style={{ flex: 1 }}></div>
              </div>

              <AntdForm.List name="priorities">
                {(fields, { add, remove }) => (
                  <>
                    <div style={{ marginTop: 10 }} />
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        background: "transparent",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              textAlign: "left",
                              fontWeight: 600,
                              color: "white",
                              padding: "8px 8px 8px 8px",
                              verticalAlign: "bottom",
                            }}
                          >
                            Priority Name
                          </th>
                          <th
                            style={{
                              textAlign: "left",
                              fontWeight: 600,
                              color: "white",
                              padding: "18px 8px 8px 8px",
                              verticalAlign: "bottom",
                            }}
                          >
                            Hours(h)
                          </th>
                          <th
                            style={{
                              textAlign: "left",
                              fontWeight: 600,
                              color: "white",
                              padding: "18px 8px 8px 8px",
                              verticalAlign: "bottom",
                            }}
                          >
                            Days(d)
                          </th>
                          <th style={{ width: 40 }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {fields.map((field, idx) => {
                          const priorities =
                            antdForm.getFieldValue("priorities") || [];
                          const row = priorities[idx] || {};
                          const hours =
                            row.hours !== undefined
                              ? row.hours
                              : row.timeline !== undefined
                                ? Number(row.timeline)
                                : undefined;
                          const days =
                            row.days !== undefined
                              ? row.days
                              : hours !== undefined
                                ? Number(hours) / 8
                                : undefined;
                          return (
                            <tr key={field.key}>
                              <td style={{ padding: 8 }}>
                                <AntdForm.Item
                                  {...field}
                                  name={[field.name, "priority"]}
                                  fieldKey={[field.fieldKey, "priority"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Enter priority name",
                                    },
                                  ]}
                                  style={{ marginBottom: 0 }}
                                >
                                  {/* <Input
                                    placeholder="Priority Name"
                                    className="priority-table-input"
                                    style={{
                                      height: "36px",
                                      display: "flex",
                                      alignItems: "center",
                                      color: "white",
                                    }}
                                    onChange={(e) => {
                                      antdForm.setFieldsValue({
                                        priorities: (
                                          antdForm.getFieldValue(
                                            "priorities"
                                          ) || []
                                        ).map((row, i) =>
                                          i === idx
                                            ? {
                                              ...row,
                                              priority: e.target.value,
                                            }
                                            : row
                                        ),
                                      });
                                    }}
                                  /> */}
                                  <Select
                                    options={priorityListData}
                                    placeholder="Select priority list"
                                    optionFilterProp="label"
                                    style={{
                                      width: "100%",
                                      maxWidth: 500,
                                      background: "transparent",
                                      border: "1px solid #fff",
                                      borderRadius: "8px",
                                      boxShadow: "none",
                                    }}
                                    className="white-dropdown custom-priority-select"
                                    value={
                                      antdForm.getFieldValue("priorities")?.[
                                        idx
                                      ]?.priority
                                    }
                                    onChange={(value) => {
                                      const priorities =
                                        antdForm.getFieldValue("priorities") ||
                                        [];

                                      const updatedPriorities = priorities.map(
                                        (row, i) =>
                                          i === idx
                                            ? {
                                                ...row,
                                                priority: value,
                                                hours:
                                                  priorityHoursMap[value] || "", // 👈 auto populate hours
                                                days: priorityHoursMap[value]
                                                  ? Number(
                                                      (
                                                        priorityHoursMap[
                                                          value
                                                        ] / 8
                                                      ).toFixed(2),
                                                    )
                                                  : "",
                                                timeline:
                                                  priorityHoursMap[value] || "",
                                              }
                                            : row,
                                      );

                                      antdForm.setFieldsValue({
                                        priorities: updatedPriorities,
                                      });
                                    }}
                                    getPopupContainer={(triggerNode) =>
                                      triggerNode.parentNode
                                    }
                                  />
                                </AntdForm.Item>
                              </td>
                              <td style={{ padding: 8 }}>
                                <AntdForm.Item
                                  {...field}
                                  name={[field.name, "hours"]}
                                  fieldKey={[field.fieldKey, "hours"]}
                                  style={{ marginBottom: 0 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Entered hours",
                                    },
                                    {
                                      validator: (_, value) =>
                                        value > 0
                                          ? Promise.resolve()
                                          : Promise.reject(
                                              "Hours must be greater than 0",
                                            ),
                                    },
                                  ]}
                                >
                                  <CustomSpinInput
                                    name="hours"
                                    value={hours}
                                    onChange={(val) => {
                                      const priorities =
                                        antdForm.getFieldValue("priorities") ||
                                        [];
                                      if (
                                        val === undefined ||
                                        val === null ||
                                        val === ""
                                      ) {
                                        antdForm.setFieldsValue({
                                          priorities: priorities.map(
                                            (row, i) =>
                                              i === idx
                                                ? {
                                                    ...row,
                                                    hours: "",
                                                    days: "",
                                                    timeline: "",
                                                  }
                                                : row,
                                          ),
                                        });
                                      } else {
                                        const newDays =
                                          val === ""
                                            ? ""
                                            : Number((val / 8).toFixed(2));
                                        antdForm.setFieldsValue({
                                          priorities: priorities.map(
                                            (row, i) =>
                                              i === idx
                                                ? {
                                                    ...row,
                                                    hours: val,
                                                    days: newDays,
                                                    timeline: val,
                                                  }
                                                : row,
                                          ),
                                        });
                                      }
                                    }}
                                    min={1}
                                    max={200}
                                    step={1}
                                    placeholder="Hours"
                                    style={{
                                      width: "100%",
                                      height: "36px",
                                      color: "white",
                                      background: "transparent",
                                    }}
                                  />
                                </AntdForm.Item>
                              </td>
                              <td style={{ padding: 8 }}>
                                <AntdForm.Item
                                  {...field}
                                  name={[field.name, "days"]}
                                  fieldKey={[field.fieldKey, "days"]}
                                  style={{ marginBottom: 0 }}
                                  rules={[
                                    { required: true, message: "Enter days" },
                                    {
                                      validator: (_, value) =>
                                        value > 0
                                          ? Promise.resolve()
                                          : Promise.reject(
                                              "Days must be greater than 0",
                                            ),
                                    },
                                  ]}
                                >
                                  <CustomSpinInput
                                    name="days"
                                    value={days}
                                    onChange={(val) => {
                                      const priorities =
                                        antdForm.getFieldValue("priorities") ||
                                        [];
                                      if (
                                        val === undefined ||
                                        val === null ||
                                        val === ""
                                      ) {
                                        antdForm.setFieldsValue({
                                          priorities: priorities.map(
                                            (row, i) =>
                                              i === idx
                                                ? {
                                                    ...row,
                                                    days: "",
                                                    hours: "",
                                                    timeline: "",
                                                  }
                                                : row,
                                          ),
                                        });
                                      } else {
                                        const newHours = val * 8;
                                        antdForm.setFieldsValue({
                                          priorities: priorities.map(
                                            (row, i) =>
                                              i === idx
                                                ? {
                                                    ...row,
                                                    days: val,
                                                    hours: newHours,
                                                    timeline: newHours,
                                                  }
                                                : row,
                                          ),
                                        });
                                      }
                                    }}
                                    min={1}
                                    max={100}
                                    step={1}
                                    placeholder="Days"
                                    style={{
                                      width: "100%",
                                      height: "36px",
                                      color: "white",
                                      background: "transparent",
                                    }}
                                  />
                                </AntdForm.Item>
                              </td>
                              <td style={{ padding: 8, textAlign: "center" }}>
                                {fields.length > 1 && (
                                  <span
                                    onClick={() => remove(field.name)}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginTop: 2,
                                      marginLeft: 8,
                                    }}
                                    title="Delete"
                                  >
                                    <DeleteIcon
                                      style={{
                                        width: 18,
                                        height: 18,
                                        verticalAlign: "middle",
                                      }}
                                    />
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <AntdForm.Item>
                      {fields.length >= 10 ? (
                        <div
                          style={{ color: "red", fontSize: 13, marginTop: 8 }}
                        >
                          Maximum 10 priorities allowed.
                        </div>
                      ) : (
                        <AntdButton
                          type="dashed"
                          onClick={() => {
                            if (fields.length < 10)
                              add({ priority: "", hours: "", days: "" });
                          }}
                          style={{
                            marginTop: 12,
                            marginLeft: 10,
                            background: "#4EB6EE",
                            color: "#fff",
                            borderColor: "#4EB6EE",
                            borderRadius: "8px",
                            fontWeight: 400,
                          }}
                        >
                          + Add Row
                        </AntdButton>
                      )}
                    </AntdForm.Item>
                  </>
                )}
              </AntdForm.List>
            </AntdForm>
          </Modal.Body>
          <Modal.Footer style={{ padding: "0px 10px 10px 10px" }}>
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={loading}
              style={{
                minWidth: "100px",
                height: "40px",
                borderRadius: "8px",
                fontWeight: 400,
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => antdForm.submit()}
              disabled={loading}
              style={{
                background: "#4EB6EE",
                color: "#fff",
                borderColor: "#4EB6EE",
                borderRadius: "8px",
                fontWeight: 400,
                minWidth: "100px",
                height: "40px",
              }}
            >
              {loading
                ? editRow
                  ? "Updating..."
                  : "Adding..."
                : editRow
                  ? "Update"
                  : "Add"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={cancelDelete}
        centered
        contentClassName="custom-delete-modal"
        backdrop="static"
        size="lg"
      >
        <div
          style={{
            background: "#36393f",
            borderRadius: 16,
            padding: "28px 24px 20px 24px",
            textAlign: "center",
            minWidth: 380,
            boxShadow: "0 2px 16px rgba(0,0,0,0.18)",
          }}
        >
          <div
            style={{
              fontSize: 20,
              color: "#fff",
              marginBottom: 18,
              fontWeight: 500,
            }}
          >
            {rowToDelete ? (
              <>
                Are you sure to delete{" "}
                <span style={{ color: "#4EB6EE" }}>
                  {rowToDelete.projectName}
                </span>
                ?
              </>
            ) : (
              "Are you sure to delete this?"
            )}
          </div>
          {error && (
            <div style={{ color: "red", marginBottom: 8, fontSize: 14 }}>
              {error}
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
            <Button
              onClick={confirmDelete}
              disabled={loading}
              style={{
                background: "#4EB6EE",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                minWidth: 80,
                fontWeight: 500,
                marginRight: 8,
              }}
            >
              {loading ? <Spinner /> : "Yes"}
            </Button>
            <Button
              onClick={cancelDelete}
              disabled={loading}
              style={{
                background: "#4EB6EE",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                minWidth: 80,
                fontWeight: 500,
              }}
            >
              No
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AddnewPriority;
